import React from "react";
import Table from "react-bootstrap/Table";
import {
  GetInitialPackageText,
  SeparateCountryCodeFromNumber,
  ToPersianNumber,
  DateToPersianNumber,
} from "../../../functions/index";
function LinesExtended(props) {
  return (
    <Table responsive className="roundedCorners">
      <thead>
        <tr>
          {props.heading.map((h, index) => (
            <th key={index}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.data &&
          props.data.map((d, index) => (
            <tr key={index}>
              <td className="ltr">
                {ToPersianNumber(SeparateCountryCodeFromNumber(d.LineNumber))}
              </td>
              <td>{GetInitialPackageText(d.initialPackage)}</td>
              <td>{DateToPersianNumber(d.PersianActivationDate)}</td>
              <td> {DateToPersianNumber(d.PersianExpirationDate)}</td>              
            </tr>
          ))}
      </tbody>
    </Table>
  );
}
export default LinesExtended;
